import React, {
  useContext,
  useMemo,
} from 'react';
import PropTypes from 'prop-types';
import TmntContext from '../../context/tmnt';

export default function TmntText({
  k,
  replacements = null,
  className = '',
  textOnly = false,
  html = false,
}) {
  const tmnts = useContext(TmntContext);

  const txt = useMemo(() => {
    if (!tmnts) return '';
    const stringValue = tmnts[k]?.value || '';

    return replacements
      ? stringValue.replace(/{([\w-]+?)}/g, (match, capture) => replacements[capture] || match)
      : stringValue;
  }, [tmnts, k, replacements]);

  if (textOnly) return txt;

  if (html) return <span className={className} data-property={k} data-testid={`tmnt-${k}`} dangerouslySetInnerHTML={{ __html: txt }} />;

  return (
    <span className={className} data-property={k} data-testid={`tmnt-${k}`}>{txt}</span>
  );
}

TmntText.propTypes = {
  k: PropTypes.string.isRequired,
  replacements: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
  textOnly: PropTypes.bool,
  html: PropTypes.bool,
};
